import { useEffect, useState } from "react";
import sanityClient from "../../client";
import { urlFor } from "../../utils/imageUrl";

import "./index.css";

export const Footer = () => {
  const [data, setData] = useState([]);
  const [navData, setNavData] = useState([]);
  const [linksData, setLinksData] = useState([]);

  const fetchData = async () => {
    try {
      const query = `*[_type == 'footer'][0] {
                backgroundImage { asset },
                logo { asset },
                navigation,
                links[] { url, title }
            }`;
      const result = await sanityClient.fetch(query);
      setData(result);
      setNavData(result.navigation);
      setLinksData(result.links);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <footer className="footer">
      {data && data.backgroundImage ? (
        <img
          className="footer-background"
          src={urlFor(data.backgroundImage.asset._ref).width(1920).url()}
          alt=""
          loading="lazy"
        />
      ) : null}
      <div className="footer-items">
        <div className="footer-navigation">
          {data && navData && (
            <ul>
              {navData.map((item, index) => (
                <a key={index} href={`/${item}`}>
                  {item}
                </a>
              ))}
            </ul>
          )}
        </div>
        <div className="footer-links">
          {data && linksData && (
            <ul>
              {linksData.map((item, index) => (
                <a key={index} href={item.url}>
                  {item.title}
                </a>
              ))}
            </ul>
          )}
        </div>
      </div>
      {data && data.logo && (
        <div className="footer-logo">
          <img
            src={urlFor(data.logo.asset._ref).width(900).url()}
            alt="Logo"
            loading="lazy"
          />
        </div>
      )}
    </footer>
  );
};
